<div class="d-flex justify-content-between align-items-center">
  <button class="register-button btn btn-primary" (click)="onSubmit()" [disabled]="buttonDisabled()">
    <span class="p-2">{{ "action.register" | translate }}</span>
  </button>
</div>
